import CMSService from './CMSService';
import APIService from './APIService';

export const cmsService = new CMSService();
export const apiService = new APIService();
